import React from 'react';
import { useTranslation } from 'react-i18next';
import IncognitoIcon from '@images/footer-icons/incognito-new.png';
import LegalIcon from '@images/footer-icons/legal-new.png';
import SafeIcon from '@images/footer-icons/safe-new.png';
import { LazyLoadImage } from 'react-lazy-load-image-component';

/**
 * Safe Icons
 * @returns {JSX.Element}
 * @constructor
 */
const SafeIcons = () => {
  const { t } = useTranslation();
  return (
    <div className="safe-icons flex justify-center space-x-3 sm:space-x-20">
      <div>
        <LazyLoadImage src={IncognitoIcon} alt="safe icnos" className="w-10 sm:w-16 p-1 sm:p-2 mx-auto" />
        {/*<img loading="lazy" src={IncognitoIcon} alt="safe icnos" className="w-10 sm:w-16 p-1 sm:p-2 mx-auto" />*/}
        <p className="text-center font-semibold font-xs text-black mt-5 opacity-50">
          100% {t('Incognito').toUpperCase()}
        </p>
      </div>
      <div>
        <LazyLoadImage src={SafeIcon} alt="safe icnos" className="w-10 sm:w-16 p-1 sm:p-2 mx-auto" />
        {/*<img loading="lazy" src={SafeIcon} alt="safe icnos" className="w-10 sm:w-16 p-1 sm:p-2 mx-auto" />*/}
        <p className="text-center font-semibold font-xs text-black mt-5 opacity-50">100% {t('Safe').toUpperCase()}</p>
      </div>
      <div>
        <LazyLoadImage src={LegalIcon} alt="safe icnos" className="w-10 sm:w-16 p-1 sm:p-2 mx-auto" />
        {/*<img loading="lazy" src={LegalIcon} alt="safe icnos" className="w-10 sm:w-16 p-1 sm:p-2 mx-auto" />*/}
        <p className="text-center font-semibold font-xs text-black mt-5 opacity-50">100% {t('Legal').toUpperCase()}</p>
      </div>
    </div>
  );
};

export default SafeIcons;
